/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { routerActions } from 'react-router-redux';
import {
  Button,
  Modal,
} from 'react-bootstrap';
import IntlMsg from 'lorautils/intl/IntlMsg';
import appActions from 'loraactions/app';
import usageActions from 'loraactions/usage';


const defaultProps = {
  show: false,
  error: null,
};

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  appId: React.PropTypes.string.isRequired,
  deleteApp: React.PropTypes.func.isRequired,
  app: React.PropTypes.object.isRequired,
  onHide: React.PropTypes.func.isRequired,
  deleted: React.PropTypes.object.isRequired,
  show: React.PropTypes.bool,
};

class DeleteAppModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      app: props.app,
      show: props.show,
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.detailview.delete');
    this.handleDelete = this.handleDelete.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { app, deleted, show, getAppsUsage } = nextProps;
    if (app !== this.props.app) {
      this.setState({ app });
    }
    if (deleted !== this.props.deleted) {
      if (deleted.status === 'success') {
        getAppsUsage();
        nextProps.pushState('/application');
      }
    }
    if (show !== this.props.show) {
      this.setState({ show });
    }
  }

  handleDelete() {
    const { appId, deleteApp } = this.props;
    deleteApp(appId);
  }

  render() {
    const { appId, onHide } = this.props;
    const { app: { data = {} }, show } = this.state;

    return (
      <Modal
        bsClass="aisz-modal-danger"
        show={show}
        onHide={onHide}
      >
        <Modal.Header closeButton>
          <div className="text-center">
            {this.intlMsg.msg('modalheader')}
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <p>
              {this.intlMsg.msg('modalcontent')}{' '}
              <strong>{data.name}({appId})</strong> ?
            </p>
            <Button bsStyle="aisz-warning" onClick={onHide}>
              <i className="fa fa-repeat" />
              {' '}
              {this.intlMsg.msg('cancelbtn')}
            </Button>
            {' '}
            <Button bsStyle="aisz-danger" onClick={this.handleDelete}>
              <i className="fa fa-trash-o" />
              {' '}
              {this.intlMsg.msg('confirmbtn')}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

DeleteAppModal.defaultProps = defaultProps;
DeleteAppModal.propTypes = propTypes;

const mapStateToProps = state => ({
  deleted: state.app.deleteApp,
  app: state.app.getApp,
});

const mapDispatchToProps = {
  deleteApp: appActions.deleteApp,
  pushState: routerActions.push,
  getAppsUsage: usageActions.apps,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(DeleteAppModal));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/DetailView/coms/DeleteAppModal/index.jsx